import React from "react";
import Footer from "../Common/Footer";

const Home = () => {
  return (
    <div>
      <>
        <div className="wrapper">
          <div className="main-section">
            <section className="main-banner">
              <div className="container">
                <div className="row align-items-center">
                  <div className="Banner-side"> </div>
                  <div className="col-lg-7 col-md-7">
                    <div
                      className="banner-text fadeInLeft wow"
                      data-wow-duration="1000ms"
                    >
                      <h2>
                        The Smarter Way to Learn <span>Anything</span>
                      </h2>
                      <p>
                        Mauris malesuada enim eget blandit gravida. Duis
                        hendrerit cursus turpis, id mollis est rutrum nec. Sed
                        interdum nisi id libero tincidunt, sit amet vestibulum
                        tortor porttitor. Cras ligula lacus, ullamcorper sed
                      </p>
                      <form className="search-form">
                        <input
                          type="text"
                          name="search"
                          placeholder="Search Class"
                        />{" "}
                        <button>
                          <i className="fa fa-search" />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-5">
                    <div
                      className="banner-img wow zoomIn"
                      data-wow-duration="1000ms"
                    >
                      <img src="assets/img/banner-img.png" alt="" />
                    </div>
                    {/*banner-img end*/}
                    <div
                      className="elements-bg wow zoomIn"
                      data-wow-duration="1000ms"
                    />
                  </div>
                </div>
              </div>
            </section>
            {/*main-banner end*/}
            <h2 className="main-title">Trinity</h2>
          </div>
          {/*main-section end*/}
          <section className="about-us-section">
            <div className="container">
              <div className="element-spring-roll"></div>
              <div className="text-center section-title">
                <h2>
                  Welcome to <span>Shelly</span>
                </h2>
                <p>
                  Nunc consectetur ex nunc, id porttitor leo semper eget.
                  Vivamus interdum, mauris quis cursus sodales, urn
                </p>
              </div>

              {/*section-title end*/}
              <div className="about-sec">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="abt-col fadeInUp wow"
                        data-wow-duration="1000ms"
                      >
                        <img src="assets/img/icon5.png" alt="" />
                        <h3>Awesome Teachers</h3>
                        <p>
                          Vivamus interdum, mauris interdum quis curdum sodales
                        </p>
                      </div>
                      {/*abt-col end*/}
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="abt-col fadeInUp wow"
                        data-wow-duration="1000ms"
                        data-wow-delay="200ms"
                      >
                        <img src="assets/img/icon7.png" alt="" />
                        <h3>Global Certificate</h3>
                        <p>
                          Pelleneget tespharetra que fringilla egugue id eget
                          pharetra
                        </p>
                      </div>
                      {/*abt-col end*/}
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="abt-col fadeInUp wow"
                        data-wow-duration="1000ms"
                        data-wow-delay="400ms"
                      >
                        <img src="assets/img/icon8.png" alt="" />
                        <h3>Best Programm</h3>
                        <p>
                          Etiam risus neque, volutpat vel laoreet a, finibus
                          volutpat non
                        </p>
                      </div>
                      {/*abt-col end*/}
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="abt-col fadeInUp wow"
                        data-wow-duration="1000ms"
                        data-wow-delay="600ms"
                      >
                        <img src="assets/img/icon9.png" alt="" />
                        <h3>Student Support Service</h3>
                        <p>
                          Mauris nec mi fequis ugiat, cursus tortor nec,
                          pharetra tellus
                        </p>
                      </div>
                      {/*abt-col end*/}
                    </div>
                  </div>
                </div>
              </div>
              {/*about-rw end*/}
              <div className="abt-img">
                <ul className="masonary">
                  <li className="width1 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery1.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery1.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width2 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery2.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery2.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width3 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery4.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery4.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width4 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery6.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery6.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width5 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery8.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery8.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width6 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery7.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery7.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width7 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery9.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery9.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width8 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery10.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery10.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width9 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery3.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery3.jpg" alt="" />
                    </a>
                  </li>
                  <li className="width10 wow zoomIn" data-wow-duration="1000ms">
                    <a
                      href="assets/img/gallery5.jpg"
                      data-group="set1"
                      title=""
                      className="html5lightbox"
                    >
                      <img src="assets/img/gallery5.jpg" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
              {/* abt-img end*/}
            </div>
          </section>
          {/*about-us-section end*/}
          <section className="classes-section">
            <div className="container">
              <div className="sec-title">
                <h2>Our Classes</h2>
                <p>
                  Nam mattis felis id sodales rutrum. Nulla ornare tristique
                  mauris, a laoreet erat ornare sit amet. Nulla sagittis
                  faucibus lacus
                </p>
              </div>
              {/*sec-title end*/}
              <div className="classes-sec">
                <div className="row classes-carousel">
                  <div className="col-lg-3">
                    <div
                      className="classes-col fadeInUp wow"
                      data-wow-duration="1000ms"
                    >
                      <div className="class-thumb">
                        <img
                          src="assets/img/img1.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Basic English Speaking and Grammar
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Amanda Kern
                            </a>
                          </div>
                          <strong className="price">$45</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div
                      className="classes-col fadeInUp wow"
                      data-wow-duration="1000ms"
                      data-wow-delay="200ms"
                    >
                      <div className="class-thumb">
                        <img
                          src="assets/img/img2.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Natural Sciences &amp; Mathematics Courses
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Gypsy Hardinge
                            </a>
                          </div>
                          <strong className="price">$67</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div
                      className="classes-col fadeInUp wow"
                      data-wow-duration="1000ms"
                      data-wow-delay="400ms"
                    >
                      <div className="class-thumb">
                        <img
                          src="assets/img/img3.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Environmental Studies &amp; Earth Sciences
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Margje Jutten
                            </a>
                          </div>
                          <strong className="price">$89</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div
                      className="classes-col fadeInUp wow"
                      data-wow-duration="1000ms"
                      data-wow-delay="600ms"
                    >
                      <div className="class-thumb">
                        <img
                          src="assets/img/img4.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Hospitality, Leisure &amp; Sports Courses
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Hubert Franck
                            </a>
                          </div>
                          <strong className="price">$67</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="d-none">
                  <div className="col-lg-3">
                    <div className="classes-col">
                      <div className="class-thumb">
                        <img
                          src="assets/img/img1.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Basic English Speaking and Grammar
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Amanda Kern
                            </a>
                          </div>
                          <strong className="price">$45</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div className="classes-col">
                      <div className="class-thumb">
                        <img
                          src="assets/img/img2.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Natural Sciences &amp; Mathematics Courses
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Gypsy Hardinge
                            </a>
                          </div>
                          <strong className="price">$67</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div className="classes-col">
                      <div className="class-thumb">
                        <img
                          src="assets/img/img3.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Environmental Studies &amp; Earth Sciences
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Margje Jutten
                            </a>
                          </div>
                          <strong className="price">$89</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                  <div className="col-lg-3">
                    <div className="classes-col">
                      <div className="class-thumb">
                        <img
                          src="assets/img/img4.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <a href="/contact" title="" className="crt-btn">
                          <img src="assets/img/icon10.png" alt="" />
                        </a>
                      </div>
                      <div className="class-info">
                        <h3>
                          <a href="/class-single" title="">
                            Hospitality, Leisure &amp; Sports Courses
                          </a>
                        </h3>
                        <span>Mon-Fri</span> <span>10 AM - 12 AM</span>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="posted-by">
                            <img src="assets/img/ico.png" alt="" />{" "}
                            <a href="/" title="">
                              Hubert Franck
                            </a>
                          </div>
                          <strong className="price">$67</strong>
                        </div>
                      </div>
                    </div>
                    {/*classes-col end*/}
                  </div>
                </div>
                </div>
                <div className="text-center lnk-dv">
                  <a href="/classes" title="" className="btn-default">
                    Classes <i className="fa fa-long-arrow-alt-right" />
                  </a>
                </div>
              </div>
              {/*classes-sec end*/}
            </div>
          </section>
          {/*classes-section end*/}
          <section className="teachers-section d-none">
            <div className="container">
              <div className="text-center section-title">
                <h2>
                  Our Awesome
                  <br />
                  Teachers
                </h2>
                <p>
                  Quisque id ultrices tellus, ac sodales ex. Cras nec ante
                  viverra, bibendum justo eget, lacinia dui. Donec ligula
                  ligula, elementum sit amet
                </p>
              </div>
              {/*section-title end*/}
              <div className="teachers d-none">
                <div className="row">
                  <div className="col-6 col-lg-3 col-md-3 col-sm-6 full-wdth">
                    <div className="teacher">
                      <div className="teacher-img">
                        <img
                          src="assets/img/img5.jpg"
                          alt=""
                          className="w-100"
                        />
                        <div className="sc-div">
                          <ul>
                            <li>
                              <a href="/" title="">
                                <i className="fa-instagram fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-linkedin-in fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-facebook-f fab" />
                              </a>
                            </li>
                          </ul>
                          <span>
                            <img src="assets/img/plus.png" alt="" />
                          </span>
                        </div>
                      </div>
                      <div className="teacher-info">
                        <h3>
                          <a href="/" title="">
                            Polina Kerston
                          </a>
                        </h3>
                        <span>English Teacher</span>
                      </div>
                    </div>
                    {/*teacher end*/}
                  </div>
                  <div className="col-6 col-lg-3 col-md-3 col-sm-6 full-wdth">
                    <div className="teacher">
                      <div className="teacher-img">
                        <img
                          src="assets/img/img6.jpg"
                          alt=""
                          className="w-100"
                        />
                        <div className="sc-div">
                          <ul>
                            <li>
                              <a href="/" title="">
                                <i className="fa-instagram fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-linkedin-in fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-facebook-f fab" />
                              </a>
                            </li>
                          </ul>
                          <span>
                            <img src="assets/img/plus.png" alt="" />
                          </span>
                        </div>
                      </div>
                      <div className="teacher-info">
                        <h3>
                          <a href="/" title="">
                            Faadi Al Rahman
                          </a>
                        </h3>
                        <span>Instructor</span>
                      </div>
                    </div>
                    {/*teacher end*/}
                  </div>
                  <div className="col-6 col-lg-3 col-md-3 col-sm-6 full-wdth">
                    <div className="teacher">
                      <div className="teacher-img">
                        <img
                          src="assets/img/img7.jpg"
                          alt=""
                          className="w-100"
                        />
                        <div className="sc-div">
                          <ul>
                            <li>
                              <a href="/" title="">
                                <i className="fa-instagram fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-linkedin-in fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-facebook-f fab" />
                              </a>
                            </li>
                          </ul>
                          <span>
                            <img src="assets/img/plus.png" alt="" />
                          </span>
                        </div>
                      </div>
                      <div className="teacher-info">
                        <h3>
                          <a href="/" title="">
                            Chikelu Obasea
                          </a>
                        </h3>
                        <span>Art Teacher</span>
                      </div>
                    </div>
                    {/*teacher end*/}
                  </div>
                  <div className="col-6 col-lg-3 col-md-3 col-sm-6 full-wdth">
                    <div className="teacher">
                      <div className="teacher-img">
                        <img
                          src="assets/img/img8.jpg"
                          alt=""
                          className="w-100"
                        />
                        <div className="sc-div">
                          <ul>
                            <li>
                              <a href="/" title="">
                                <i className="fa-instagram fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-linkedin-in fab" />
                              </a>
                            </li>
                            <li>
                              <a href="/" title="">
                                <i className="fa-facebook-f fab" />
                              </a>
                            </li>
                          </ul>
                          <span>
                            <img src="assets/img/plus.png" alt="" />
                          </span>
                        </div>
                      </div>
                      <div className="teacher-info">
                        <h3>
                          <a href="/" title="">
                            Katayama Fumiki
                          </a>
                        </h3>
                        <span>Teacher</span>
                      </div>
                    </div>
                    {/*teacher end*/}
                  </div>
                </div>
              </div>
              {/*teachers end*/}
            </div>
          </section>
          <section className="course-section d-none">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="find-course">
                    <div className="sec-title">
                      <h2>Find Your Course</h2>
                      <p>
                        ullam fringilla ipsum sed enim scelerisque, ac porttitor
                        libero egestas. Donec iaculis nisi eget bibendum
                        efficitur. Lorem ipsum dolor sit
                      </p>
                      <h3>
                        <img src="assets/img/icon11.png" alt="" />
                        Call: <strong>+2 342 5446 67</strong>
                      </h3>
                    </div>
                    {/*sec-title end*/}
                    <div className="course-img">
                      <img src="assets/img/course-img.png" alt="" />
                    </div>
                    {/*course-img end*/}
                  </div>
                  {/*find-course end*/}
                </div>
                <div className="col-lg-6">
                  <div className="courses-list">
                    <div
                      className="course-card fadeInLeft wow"
                      data-wow-duration="1000ms"
                    >
                      <div className="d-flex flex-wrap align-items-center">
                        <ul className="course-meta">
                          <li>
                            <img src="assets/img/icon12.png" alt="" />{" "}
                            29/07/2020
                          </li>
                          <li>11AM to 15PM</li>
                        </ul>
                        <span>FREE</span>
                      </div>
                      <h3>
                        <a href="/event-single" title="">
                          Digital Transformation Conference
                        </a>
                      </h3>
                      <div className="d-flex flex-wrap">
                        <div className="posted-by">
                          <img src="assets/img/ico2.png" alt="" />{" "}
                          <a href="/" title="">
                            Amanda Kern
                          </a>
                        </div>
                        <span className="locat">
                          <img src="assets/img/loct.png" alt="" />
                          43 castle road 517 district
                        </span>
                      </div>
                    </div>
                    {/*course-card end*/}
                    <div
                      className="course-card fadeInLeft wow"
                      data-wow-duration="1000ms"
                      data-wow-delay="400ms"
                    >
                      <div className="d-flex flex-wrap align-items-center">
                        <ul className="course-meta">
                          <li>
                            <img src="assets/img/icon12.png" alt="" />{" "}
                            29/07/2020
                          </li>
                          <li>11AM to 15PM</li>
                        </ul>
                        <span>$16</span>
                      </div>
                      <h3>
                        <a href="/event-single" title="">
                          Environment conference
                        </a>
                      </h3>
                      <div className="d-flex flex-wrap">
                        <div className="posted-by">
                          <img src="assets/img/ico2.png" alt="" />{" "}
                          <a href="/" title="">
                            Cvita Doleschall
                          </a>
                        </div>
                        <span className="locat">
                          <img src="assets/img/loct.png" alt="" />
                          43 castle road 517 district
                        </span>
                      </div>
                    </div>
                    {/*course-card end*/}
                    <div
                      className="course-card fadeInLeft wow"
                      data-wow-duration="1000ms"
                      data-wow-delay="600ms"
                    >
                      <div className="d-flex flex-wrap align-items-center">
                        <ul className="course-meta">
                          <li>
                            <img src="assets/img/icon12.png" alt="" />{" "}
                            29/07/2020
                          </li>
                          <li>11AM to 15PM</li>
                        </ul>
                        <span>$8</span>
                      </div>
                      <h3>
                        <a href="/event-single" title="">
                          Campus clean workshop
                        </a>
                      </h3>
                      <div className="d-flex flex-wrap">
                        <div className="posted-by">
                          <img src="assets/img/ico2.png" alt="" />{" "}
                          <a href="/" title="">
                            Helena Brauer
                          </a>
                        </div>
                        <span className="locat">
                          <img src="assets/img/loct.png" alt="" />
                          43 castle road 517 district
                        </span>
                      </div>
                    </div>
                    {/*course-card end*/}
                  </div>
                  {/*courses-list end*/}{" "}
                  <a href="/events" title="" className="all-btn">
                    All Events <i className="fa fa-long-arrow-alt-right" />
                  </a>
                  <div className="clearfix" />
                </div>
              </div>
            </div>
          </section>
          {/*course-section end*/}
          <section className="blog-section">
            <div className="container">
              <div className="text-center section-title">
                <h2>Recent News</h2>
                <p>
                  Nam mattis felis id sodales rutrum. Nulla ornare tristique
                  mauris, a laoreet erat ornare sit amet. Nulla sagittis
                  faucibus lacusMorbi lorem sem, aliquet
                </p>
              </div>
              {/*section-title end*/}
              <div className="blog-posts">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="blog-post">
                      <div className="blog-thumbnail">
                        <img
                          src="assets/img/blog1.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <span className="category">English</span>
                      </div>
                      <div className="blog-info">
                        <ul className="meta">
                          <li>
                            <a href="/" title="">
                              17/09/2020
                            </a>
                          </li>
                          <li>
                            <a href="/" title="">
                              by Admin
                            </a>
                          </li>
                          <li>
                            <img src="assets/img/icon13.png" alt="" />
                            <a href="/" title="">
                              Teachers,
                            </a>
                            <a href="/" title="">
                              School
                            </a>
                          </li>
                        </ul>
                        <h3>
                          <a href="/post" title="">
                            Campus clean workshop
                          </a>
                        </h3>
                        <p>
                          Nam mattis felis id sodales rutrum. Nulla ornare
                          tristique mauris, a laoreet erat ornare sit amet
                        </p>
                        <a href="/post" title="" className="read-more">
                          Read <i className="fa fa-long-arrow-alt-right" />
                        </a>
                      </div>
                    </div>
                    {/*blog-post end*/}
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="blog-post">
                      <div className="blog-thumbnail">
                        <img
                          src="assets/img/blog2.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <span className="category">English</span>
                      </div>
                      <div className="blog-info">
                        <ul className="meta">
                          <li>
                            <a href="/" title="">
                              17/09/2020
                            </a>
                          </li>
                          <li>
                            <a href="/" title="">
                              by Admin
                            </a>
                          </li>
                          <li>
                            <img src="assets/img/icon13.png" alt="" />
                            <a href="/" title="">
                              Teachers,
                            </a>
                            <a href="/" title="">
                              School
                            </a>
                          </li>
                        </ul>
                        <h3>
                          <a href="/post" title="">
                            Campus clean workshop
                          </a>
                        </h3>
                        <p>
                          Nam mattis felis id sodales rutrum. Nulla ornare
                          tristique mauris, a laoreet erat ornare sit amet
                        </p>
                        <a href="/post" title="" className="read-more">
                          Read <i className="fa fa-long-arrow-alt-right" />
                        </a>
                      </div>
                    </div>
                    {/*blog-post end*/}
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="blog-post">
                      <div className="blog-thumbnail">
                        <img
                          src="assets/img/blog3.jpg"
                          alt=""
                          className="w-100"
                        />{" "}
                        <span className="category">English</span>
                      </div>
                      <div className="blog-info">
                        <ul className="meta">
                          <li>
                            <a href="/" title="">
                              17/09/2020
                            </a>
                          </li>
                          <li>
                            <a href="/" title="">
                              by Admin
                            </a>
                          </li>
                          <li>
                            <img src="assets/img/icon13.png" alt="" />
                            <a href="/" title="">
                              Teachers,
                            </a>
                            <a href="/" title="">
                              School
                            </a>
                          </li>
                        </ul>
                        <h3>
                          <a href="/post" title="">
                            Campus clean workshop
                          </a>
                        </h3>
                        <p>
                          Nam mattis felis id sodales rutrum. Nulla ornare
                          tristique mauris, a laoreet erat ornare sit amet
                        </p>
                        <a href="/post" title="" className="read-more">
                          Read <i className="fa fa-long-arrow-alt-right" />
                        </a>
                      </div>
                    </div>
                    {/*blog-post end*/}
                  </div>
                </div>
              </div>
              {/*blog-posts end*/}
            </div>
          </section>
          {/*blog-section end*/}
          <section className="newsletter-section">
            <div className="container">
              <div className="newsletter-sec">
                <div className="row align-items-center">
                  <div className="col-lg-4">
                    <div className="newsz-ltr-text">
                      <h2>
                        Join us
                        <br />
                        and stay tuned!
                      </h2>
                      <a href="/contact" title="" className="btn-default">
                        Join Us <i className="fa fa-long-arrow-alt-right" />
                      </a>
                    </div>
                    {/*newsz-ltr-text end*/}
                  </div>
                  <div className="col-lg-8">
                    <form className="newsletter-form">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <input type="text" name="name" placeholder="Name" />
                          </div>
                          {/*form-group end*/}
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="email"
                              name="email"
                              placeholder="Email"
                            />
                          </div>
                          {/*form-group end*/}
                        </div>
                        <div className="col-md-4">
                          <div className="form-group select-tg">
                            <select>
                              <option>Class</option>
                              <option>Class</option>
                              <option>Class</option>
                              <option>Class</option>
                              <option>Class</option>
                              <option>Class</option>
                            </select>
                          </div>
                          {/*form-group end*/}
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <textarea
                              name="message"
                              placeholder="Message"
                              defaultValue={""}
                            />
                          </div>
                          {/*form-group end*/}
                        </div>
                      </div>
                    </form>
                    {/*newsletter-form end*/}
                  </div>
                </div>
              </div>
              {/*newsletter-sec end*/}
            </div>
          </section>
          {/*newsletter-sec end*/}
          <Footer />

          {/*footer end*/}
        </div>
        {/* Global site tag (gtag.js) - Google Analytics */}
      </>
    </div>
  );
};

export default Home;
